import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { Avatar, AvatarFallback, AvatarImage } from "../components/ui/avatar";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "../components/ui/dropdown-menu";
import { SignOut, House, Plus, ChartBar } from "@phosphor-icons/react";

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  if (!user) return null;

  return (
    <header className="glass-header fixed top-0 left-0 right-0 z-50 border-b border-black/5" data-testid="navbar">
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-14 flex items-center justify-between">
        <Link to="/dashboard" className="flex items-center gap-2 group" data-testid="navbar-logo">
          <img src="/logo_vector.svg" alt="Quick Assess" className="w-10 h-10" />
          <div className="flex flex-col leading-tight">
            <span className="text-[#0A0A0A] font-heading font-bold text-lg tracking-tight hidden sm:inline">
              Quick <span className="text-[#FF3366]">Assess</span>
            </span>
            <span className="text-sm text-[#52525B] hidden sm:inline">
              by KnowVex
            </span>
          </div>
        </Link>

        <nav className="flex items-center gap-1">
          <Link
            to="/dashboard"
            className="flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium text-[#52525B] hover:text-[#0A0A0A] hover:bg-black/5 transition-colors"
            data-testid="nav-dashboard"
          >
            <House size={16} />
            <span className="hidden sm:inline">Dashboard</span>
          </Link>
          <Link
            to="/create-assessment"
            className="flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium text-[#52525B] hover:text-[#0A0A0A] hover:bg-black/5 transition-colors"
            data-testid="nav-create"
          >
            <Plus size={16} />
            <span className="hidden sm:inline">Create</span>
          </Link>

          <div className="w-px h-5 bg-black/10 mx-2" />

          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <button className="flex items-center gap-2 outline-none" data-testid="user-menu-trigger">
                <Avatar className="h-7 w-7 rounded-none">
                  <AvatarImage src={user.picture} alt={user.name} />
                  <AvatarFallback className="rounded-none bg-[#F8F9FA] text-[#0A0A0A] text-xs font-semibold">
                    {user.name?.[0]?.toUpperCase() || "U"}
                  </AvatarFallback>
                </Avatar>
              </button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="w-48 rounded-none border-black/10">
              <div className="px-3 py-2 border-b border-black/5">
                <p className="text-xs font-semibold text-[#0A0A0A] truncate">{user.name}</p>
                <p className="text-[10px] text-[#52525B] truncate">{user.email}</p>
              </div>
              <DropdownMenuItem
                onClick={handleLogout}
                className="rounded-none text-xs cursor-pointer"
                data-testid="logout-button"
              >
                <SignOut size={14} className="mr-2" />
                Sign out
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </nav>
      </div>
    </header>
  );
}
